<template>
  <div class="coupon-box">
    <div class="coupon-list">
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell v-for="(item, i) in state.list" :key="i + '-list'">
          <template #value>
            <div class="recycle-item">
              <img :src="item.pic1" @click="goGamedetails(item.gid)" />
              <div class="recycle-info" @click="goGamedetails(item.gid)">
                <!-- <h3>{{ item.gamename }}</h3> -->
                <div class="div-mid">
                  <h3>{{ item.gamename }}</h3>
                </div>
                <p>区服：{{ item.servername }}</p>
                <p>金额：¥{{ item.pay_money }}</p>
                <p>购买时间：{{ time(item.pay_time) }}</p>
              </div>
            </div>
          </template>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import { reactive, computed } from "vue";
import { useRouter } from "vue-router";
import { snatchBuyRecord } from "@/api/yzuser";
import { dateMDHM } from "@/utils/date";
import { useStore } from "vuex";
import { Toast } from "vant";
import defaultimg1 from "@/assets/defaultimg/error2.png";
import { getQueryString } from "@/utils/location";

export default {
  name: "couponcenter",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      noimg: defaultimg1,
      list: [],
      loading: false,
      finished: false,
    });

    const coupondate = (pagecode) => {
      let totalPage;
      snatchBuyRecord({
        uid: getQueryString("uid"),
        pagecode: pagecode,
      }).then((response) => {
        console.log(response);
        if (response.data.a == 1) {
          let list = response.data.c.lists;
          totalPage = response.data.c.total_page;
          state.list = state.list.concat(list);
          // 加载状态结束
          state.loading = false;
          // 数据全部加载完成
          if (pagecode >= totalPage) {
            state.finished = true;
          }
        } else {
          Toast(response.data.b);
        }
      });
    };

    const onClickLeft = () => {
      router.back();
    };

    // 时间戳转换
    const time = computed(() => {
      return function(date) {
        return dateMDHM(date);
      };
    });

    const goGamedetails = (gid) => {
      // router.push({
      // 	path: "/gamedetails",
      // 	query: {
      // 		gid: gid,
      // 		edition: "0",
      // 	},
      // });
      window.document.location = "gogame://" + gid;
    };

    let pagecode = 1;
    // 加载数据
    const onLoad = () => {
      // 异步更新数据
      coupondate(pagecode);
      pagecode++;
    };

    return {
      state,
      onClickLeft,
      onLoad,
      goGamedetails,
      time,
    };
  },
};
</script>

<style scoped src="../../../styles/removeVantcell.css"></style>
<style scoped="scoped">
.coupon-box {
  padding-top: calc(100px + constant(safe-area-inset-top));
  padding-top: calc(100px + env(safe-area-inset-top));
  background: #f7f8fa;
  padding-top: 20px;
  min-height: 100vh;
}

.recycle-item {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 24px;
  margin: 24px;
  border-radius: 10px;
}

.recycle-item img {
  width: 160px;
  height: 160px;
}

.recycle-info {
  padding-left: 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.recycle-item .recycle-info h3 {
  font-size: 30px;
  color: #333;
}

.recycle-item .recycle-info p {
  font-size: 20px;
  color: #333;
  margin: 6px 0;
}

.recycle-item .btn-recycle {
  color: #333;
  width: 160px;
  height: 50px;
  border-radius: 50px;
  background: #2acbaf;
  font-size: 26px;
  text-align: center;
  line-height: 50px;
  margin-top: 35px;
}

.div-mid {
  display: flex;
}

.div-mid p:nth-of-type(1) {
  color: #2acbaf;
  background-color: #e3fffd;
  font-size: 24px;
  margin-left: 3px;
  border-radius: 4px;
}
</style>
